import React from 'react';
const LOGO_SRC = 'https://cdn.magicpatterns.com/uploads/9UZFCK3enFh6xEX5XGuNGm/84de689e-fe1a-413a-9d0b-17576ac80ca6.png';
type LogoProps = {
  className?: string;
  /** Renders the small letterspaced descriptor beneath the logo. */
  showTagline?: boolean;
  /** Tailwind height class for the logo image. */
  size?: string;
};
export function Logo({
  className = '',
  showTagline = false,
  size = 'h-14'
}: LogoProps) {
  return <span className={`flex flex-col items-start leading-none ${className}`} data-id="element-72" data-mp="mu5qzxguqt18">
      <img src={LOGO_SRC} alt="Me Time — massage and wellness" className={`${size} w-auto object-contain object-left`} data-id="element-73" data-mp="rs79ohad8qc6" />
      {showTagline && <span className="-mt-1 text-[9px] font-medium uppercase tracking-[0.34em] text-beige/50" data-id="element-74" data-mp="hthtqu215fyk">
          Massage &amp; Wellness
        </span>}
    </span>;
}